import React from "react";
import SecUsersContainer from "../../container/secUsers";

const SecUsersScreen: React.FC<{}> = () => {
    return <SecUsersContainer/>;
}

export default SecUsersScreen;